import Draggable from 'vuedraggable';

import dragMixin from '@/mixins/drag';

/**
 * Sortable chip list using vuedraggable.
 *
 * Handles drag-and-drop reordering and delegates item rendering to parent via default slot.
 * The parent is responsible for reordering logic on the `reorder` event.
 *
 * @emits reorder - { oldIndex: number, newIndex: number }
 *
 * @example
 * <ChipList
 *     value={list}
 *     disabled={disabled}
 *     onReorder={({ oldIndex, newIndex }) => { ... }}
 * >
 *     {list.map(item => <Chip key={item.key} ... />)}
 * </ChipList>
 */
export default {
    name: 'ChipList',
    mixins: [dragMixin({ cursorNormal: 'grab' })],
    props: {
        value: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    render() {
        const { value, disabled } = this;

        return (
            <Draggable
                disabled={disabled}
                value={value}
                animation={200}
                group="row"
                ghostClass="ghost"
                class="drag-area"
                forceFallback={true}
                on={{
                    start: () => (this.drag = true),
                    end: ({ oldIndex, newIndex }) => {
                        this.$emit('reorder', { oldIndex, newIndex });
                        this.drag = false;
                    },
                }}
            >
                {this.$slots.default}
            </Draggable>
        );
    },
};
